<template>
  <div>
    <!-- <p style="text-align: center;" v-if="loading">Loading...</p> -->
    <transition name="fade" mode="out-in">
      <a
        class="button is-link is-loading is-large is-fullwidth"
        v-if="loading && !finished"
        key="loading"
        >Loading</a
      >
      <div v-if="finished" id="bank_verification_in_progress">
        <h3 style="margin-top: 30px">Bank Verification in Progress</h3>
        <p>
          Please do not close this page while we finish verifying your identity.
          This should only take a few (minutes/seconds).
        </p>
        <div class="buttons is-right">
          <!-- <a class="button is-link padded-button next-button is-loading" @click="next">Continue</a> -->
          <a
            class="button is-link padded-button next-button is-loading"
            @click="next"
            >Continue</a
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import $ from "jquery";

function setWithExpiry(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "Plaid",
  components: {},
  props: {
    api: String,
    link: String,
    redirect_url: String,
  },
  data() {
    return {
      loading: true,
      finished: false,
      finresult: false,
      reviewIndex: 0,
      obj: "financials",
      item_id: null,
      access_token: null,
      inputs: {
        item_id: "",
        access_token: "", //asset_report_token
        item_access_token: "", //access_token will be used to remove
        verified_revenue: "",
        verified_adb: "",
        last_three_months: "",
        has_mca_payments_by_month: "",
        has_biz_account: "",
        MCA_deposits: "",
        MC_Payments: "",
      },
    };
  },
  mounted: function () {
    // leer el localstorage oauth_state_id
    // si existe solo crear el objecto Plaid con los mismos parametros de abajo, usando el link token que se uso la primera vez
    var self = this;
    let oauth_token = getWithExpiry("oauth_state_id");
    console.log("oauth token:" + oauth_token);
    let link_token = getWithExpiry("link_token");
    console.log("link token:" + link_token);
    if (oauth_token && oauth_token !== "" && link_token && link_token !== "") {
      console.log("loading oauth plaid widget");
      //link token from storage
      //oauth_token from storage
      var handler = Plaid.create({
        token: link_token,
        receivedRedirectUri: window.location.href,
        // apiVersion: "v2",
        // clientName: "Cardiff",
        // env: resp.vars.environment,
        token: link_token,
        // product: ["transactions", "assets"],
        // key: resp.vars.publickey,
        // countryCodes: ["US"],
        // webhook: 'https://your-domain.tld/plaid-webhook',
        onSuccess: function (public_token) {
          self.finished = true;
          $.post(
            "/api/" + self.api + "/get_access_token",
            {
              public_token: public_token,
              sfleadid: self.link,
            },
            function (data) {
              self.item_id = data.plaid.item_id;
              self.access_token = data.plaid.access_token; //access_token
              self.inputs.item_id = data.plaid.item_id;
              self.inputs.access_token = data.token; //assetReportToken
              self.inputs.verified_revenue = data.results.revenue;
              self.inputs.last_three_months = data.results.last_three_months;

              self.inputs.verified_adb = data.results.adb;
              self.inputs.has_mca_payments_by_month =
                data.results.has_mca_payments_by_month;
              self.inputs.has_biz_account = data.results.has_biz_account;

              self.inputs.MCA_deposits = data.results.MCA_deposits;
              self.inputs.MC_Payments = data.results.MC_Payments;
              self.inputs.item_access_token = data.plaid.access_token;

              self.next();
            }
          );
        },
        onExit: function (err, metadata) {
          // The user exited the Link flow.
          if (err != null) {
            // The user encountered a Plaid API error prior to exiting.
          }
          self.next();
        },
      });
      handler.open();
    } else {
      console.log("loading regular plaid widget");

      console.log(self.api);
      console.log("redirect url", self.redirect_url);
      $.ajax({
        type: "GET",
        // url: "/api/plaid/getvars",
        url: "/api/plaid/get_link_token/?redirect_url=" + self.redirect_url,
        contentType: "application/json",
        dataType: "json",
      })
        .done(function (resp) {
          console.log(resp);
          // if (resp.vars) {
          self.loading = false;
          // console.log(resp.vars);
          setWithExpiry("link_token", resp.link_token, 900000);
          var handler = Plaid.create({
            // apiVersion: "v2",
            // clientName: "Cardiff",
            // env: resp.vars.environment,
            token: resp.link_token,
            // product: ["transactions", "assets"],
            // key: resp.vars.publickey,
            // countryCodes: ["US"],
            // webhook: 'https://your-domain.tld/plaid-webhook',
            onSuccess: function (public_token) {
              self.finished = true;
              $.post(
                "/api/" + self.api + "/get_access_token",
                {
                  public_token: public_token,
                  sfleadid: self.link,
                },
                function (data) {
                  self.item_id = data.plaid.item_id;
                  self.access_token = data.plaid.access_token; //access_token
                  self.inputs.item_id = data.plaid.item_id;
                  self.inputs.access_token = data.token; //assetReportToken
                  self.inputs.verified_revenue = data.results.revenue;
                  self.inputs.last_three_months =
                    data.results.last_three_months;

                  self.inputs.verified_adb = data.results.adb;
                  self.inputs.has_mca_payments_by_month =
                    data.results.has_mca_payments_by_month;
                  self.inputs.has_biz_account = data.results.has_biz_account;

                  self.inputs.MCA_deposits = data.results.MCA_deposits;
                  self.inputs.MC_Payments = data.results.MC_Payments;
                  self.inputs.item_access_token = data.plaid.access_token;

                  self.next();
                }
              );
            },
            onExit: function (err, metadata) {
              // The user exited the Link flow.
              if (err != null) {
                // The user encountered a Plaid API error prior to exiting.
              }
              self.next();
            },
          });
          handler.open();
          // }
        })
        .fail(function (err) {
          console.log(err);
        });
    }
  },
  methods: {
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#stars {
  max-width: 40%;
  margin: auto;
  display: block;
}
</style>
<style>
#bank_verification_in_progress {
  padding-left: 20px;
  padding-right: 20px;
}
</style>
